export const CHECK_IP_API = `https://geoip.service.blueonline.tv/api`;

export const basicAuth = window.btoa(
	`${process.env.REACT_APP_GEOIP_USERNAME}:${process.env.REACT_APP_GEOIP_PASSWORD}`
);
